<script lang="ts" setup>
const { template } = storeToRefs(useTemplateStore());

const dcStyleColor = computed(() => {
  return `${template.value.dress_code.style} - ${template.value.dress_code.color}`;
});
</script>

<template>
  <section
    id="dress-code"
    class="px-section py-section-alt max-w-section flex flex-col gap-10 md:gap-14 lg:gap-16"
  >
    <AppSectionHeaderWrapper>
      <AppSectionTitle
        data-aos="fade-up"
        data-aos-delay="500"
        data-aos-anchor="#dress-code"
      >
        DRESS CODE
      </AppSectionTitle>

      <NuxtImg
        src="/line-primary.svg"
        alt="Line Primary"
        data-aos="zoom-in"
        data-aos-delay="600"
        data-aos-anchor="#dress-code"
        class="w-line-graphic"
        loading="lazy"
        decoding="async"
      />
    </AppSectionHeaderWrapper>

    <div class="flex flex-col gap-8 text-center">
      <p
        class="text-sm mx-auto max-w-2xs xs:text-base xs:max-w-xs sm:max-w-sm xl:text-lg xl:max-w-md"
        data-aos="fade-up"
        data-aos-delay="700"
        data-aos-anchor="#dress-code"
      >
        Untuk mendukung hari bahagia ini, maka untuk para hadirin sekalian diharapkan untuk mengenakan pakaian dengan dress code berikut:
      </p>

      <h3
        class="text-base text-primary-800 md:text-lg lg:text-xl"
        data-aos="zoom-in"
        data-aos-delay="750"
        data-aos-anchor="#dress-code"
      >
        {{ dcStyleColor.toUpperCase() }}
      </h3>
    </div>

    <NuxtImg
      src="/dc-person.webp"
      alt="Dress Code Illustration"
      class="mx-auto w-[191.25px] h-auto md:h-auto md:w-70 lg:75"
      loading="lazy"
      decoding="async"
      data-aos="zoom-in-up"
      data-aos-delay="800"
      data-aos-anchor="#dress-code"
    />
  </section>
</template>
